// import React, { useEffect, useState } from "react";
// // import { FaChevronDown, FaMoon, FaSun } from "react-icons/fa";
// import { FaBars, FaTimes, FaChevronDown, FaMoon, FaSun } from "react-icons/fa";
// import Images from "./assets/Image";
// import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
// import Navbar from "./component/Navbar";
// import Footer from "./component/Footer";
// import Home from "./screens/Home";
// import KnowAs from "./screens/KnowAs";
// import UspSimacolorFluids from "./screens/products/UspSimacolorFluids";
// import UspTtoRibbons from "./screens/products/UspTtoRibbons";
// import UspStreamlinePlus from "./screens/products/UspStreamlinePlus";
// import Event from "./screens/services/Event";
// import Support from "./screens/services/Support";
// import Blog from "./screens/services/Blog";
// import ContactUs from "./screens/services/ContactUs";
// import ByIndustry from "./screens/solutions/ByIndustry";

// import Pharma from "./component/solutionscomponent/Pharma";
// import Telecom from "./component/solutionscomponent/Telecom";
// import Copulot128 from "./screens/products/Copulot128";
// import Copilot256 from "./screens/products/Copilot256";
// import CopilotMax400 from "./screens/products/CopilotMax400";
// import CopilotMax512iTurbo from "./screens/products/CopilotMax512iTurbo";
// import CopilotMaxTurbo from "./screens/products/CopilotMaxTurbo";
// import CopilotMaxlt from "./screens/products/CopilotMaxlt";
// import CopilotGemini from "./screens/products/CopilotGemini";
// import ByApplicationComp from "./component/solutionscomponent/ByApplicationComp";
// import ByApplication from "./screens/solutions/ByApplication";
// import AutoMobile from "./screens/solutions/AutoMobile";
// import BreweriesPage from "./screens/solutions/BreweriesPage";
// import Chemical from "./screens/solutions/Chemical";
// import Electrical from "./screens/solutions/Electrical";
// import FoodBeverage from "./screens/solutions/FoodBeverage";
// import PersonalCare from "./screens/solutions/PersonalCare";
// import PharmaPage from "./screens/solutions/PharmaPage";
// import TelecomAndInfrastrcture from "./screens/solutions/TelecomAndInfrastrcture";
// import UspJetStream2 from "./screens/products/UspJetStream2";
// import UspStreamLine4SP from "./screens/products/UspStreamLine4SP";
// import UspA2120 from "./screens/products/UspA2120";
// import UspCo2Laser from "./screens/products/UspCo2Laser";
// import UspHandHeldFiberLaser from "./screens/products/UspHandHeldFiberLaser";
// import UspFiberLaser from "./screens/products/UspFiberLaser";
// import UspUvLaser from "./screens/products/UspUvLaser";
// import ScrollToTop from "./component/ScrollToTop";
// import Login from "./screens/Login";
// import VerifyOtp from "./screens/otppage/VerifyOtp";
// import PersonalInfo from "./screens/otppage/PersonalInfo";

// const Navigation = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   let logintrue = sessionStorage.getItem("auth");
//   const [visibleIcons, setVisibleIcons] = useState([
//     false,
//     false,
//     false,
//     false,
//     false,
//   ]);

//   const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

//   useEffect(() => {
//     if (isOpen) {
//       // Loop to show icons with delay (bottom to top)
//       for (let i = 0; i < 5; i++) {
//         setTimeout(() => {
//           setVisibleIcons((prev) => {
//             const updated = [...prev];
//             updated[4 - i] = true; // Show from last to first
//             return updated;
//           });
//         }, i * 150); // delay 300ms between icons
//       }
//     } else {
//       // Reset all to false when closing
//       setVisibleIcons([false, false, false, false, false]);
//     }
//   }, [isOpen]);

//   useEffect(() => {
//     document.body.setAttribute("data-theme", theme);
//     localStorage.setItem("theme", theme);
//   }, [theme]);

//   const toggleTheme = () => {
//     setTheme(theme === "light" ? "dark" : "light");
//   };

//   return (
//     <div className="">
//       <BrowserRouter>
//         <ScrollToTop />
//         {logintrue == true ? (
//           <>
//             {" "}
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route
//                 path="/product/uspSimacolorFluids"
//                 element={<UspSimacolorFluids />}
//               />
//               <Route
//                 path="/product/uspTtoRibbons"
//                 element={<UspTtoRibbons />}
//               />
//               <Route
//                 path="/product/uspStreamlinePlus"
//                 element={<UspStreamlinePlus />}
//               />
//               <Route
//                 path="/product/uspStreamLine4SP"
//                 element={<UspStreamLine4SP />}
//               />
//               <Route path="/product/uspCo2Laser" element={<UspCo2Laser />} />
//               <Route
//                 path="/product/uspHandHeldFiberLaser"
//                 element={<UspHandHeldFiberLaser />}
//               />
//               <Route
//                 path="/product/uspFiberLaser"
//                 element={<UspFiberLaser />}
//               />
//               <Route path="/product/uspUvLaser" element={<UspUvLaser />} />
//               <Route
//                 path="/product/uspJetStream2"
//                 element={<UspJetStream2 />}
//               />
//               <Route path="/product/uspA2120" element={<UspA2120 />} />
//               <Route path="/product/Copulot128" element={<Copulot128 />} />
//               <Route path="/product/copilot256" element={<Copilot256 />} />
//               <Route
//                 path="/product/copilotMax400"
//                 element={<CopilotMax400 />}
//               />
//               <Route
//                 path="/product/copilotMax512iTurbo"
//                 element={<CopilotMax512iTurbo />}
//               />
//               <Route
//                 path="/product/copilotMaxTurbo"
//                 element={<CopilotMaxTurbo />}
//               />
//               <Route path="/product/copilotMaxlt" element={<CopilotMaxlt />} />
//               <Route
//                 path="/product/copilotGemini"
//                 element={<CopilotGemini />}
//               />
//               <Route path="/knowAs" element={<KnowAs />} />
//               <Route path="/services/support" element={<Support />} />
//               <Route path="/services/event" element={<Event />} />
//               <Route path="/services/blog" element={<Blog />} />
//               <Route path="/services/contactus" element={<ContactUs />} />
//               <Route path="/solutions/byIndustry" element={<ByIndustry />} />
//               <Route
//                 path="/solutions/byApplication"
//                 element={<ByApplication />}
//               />
//               <Route path="/byindustry/automobile" element={<AutoMobile />} />
//               <Route path="/byindustry/breweries" element={<BreweriesPage />} />
//               <Route path="/byindustry/chemical" element={<Chemical />} />
//               <Route path="/byindustry/electrical" element={<Electrical />} />
//               <Route
//                 path="/byindustry/foodandbeverage"
//                 element={<FoodBeverage />}
//               />
//               <Route
//                 path="/byindustry/personalCare"
//                 element={<PersonalCare />}
//               />
//               <Route path="/byindustry/pharma" element={<PharmaPage />} />
//               <Route
//                 path="/byindustry/telecom"
//                 element={<TelecomAndInfrastrcture />}
//               />
//             </Routes>
//           </>
//         ) : (
//           <>
//             <Routes>
//               <Route path="/" element={<Login />} />
//               <Route path="/verifyotp" element={<VerifyOtp />} />
//               <Route path="/personalInformation" element={<PersonalInfo />} />
//             </Routes>
//           </>
//         )}
//       </BrowserRouter>

//       {logintrue == true ? (
//         <>
//           {" "}
//           <div className="theme-toggle" onClick={toggleTheme}>
//             {theme === "light" ? <FaMoon /> : <FaSun />}
//           </div>
//         </>
//       ) : (
//         <></>
//       )}

//       {isOpen && (
//         <>
//           <div className="blog_share_icons_block show">
//             {[
//               Images?.whatsappIcon,
//               Images?.youtueIcon,
//               Images?.facebookIcon,
//               Images?.linkedin,
//               Images?.instagramIcon,
//             ].map((src, index) => (
//               <img
//                 key={index}
//                 src={src}
//                 alt="icon"
//                 className={`blog_share_icones_sizes ${
//                   visibleIcons[index] ? "showIcon" : ""
//                 }`}
//               />
//             ))}
//           </div>
//           <div
//             className="blog_bottom_share"
//             onClick={() => {
//               setIsOpen(false);
//             }}
//           >
//             x
//           </div>
//         </>
//       )}

//       {!isOpen && !logintrue && (
//         <>
//           <button className="blog_content_bottom_btn">
//             tap to connect here
//           </button>
//           <div
//             className="blog_bottom_share"
//             onClick={() => {
//               setIsOpen(true);
//             }}
//           >
//             +
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Navigation;

import React, { useEffect, useState } from "react";
import { FaBars, FaTimes, FaChevronDown, FaMoon, FaSun } from "react-icons/fa";

import Images from "./assets/Image";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SOCIAL_LINKS } from "./utils/constants";

import ScrollToTop from "./component/ScrollToTop";
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";

import Home from "./screens/Home";
import KnowAs from "./screens/KnowAs";

import UspSimacolorFluids from "./screens/products/UspSimacolorFluids";
import UspTtoRibbons from "./screens/products/UspTtoRibbons";
import UspStreamLine4SP from "./screens/products/UspStreamLine4SP";
import UspTto03s05s from "./screens/products/UspTto03s05s";

import CopilotAll from "./screens/products/CopilotAll";
import CopilotMax400 from "./screens/products/CopilotMax400";
import CopilotMax512iTurbo from "./screens/products/CopilotMax512iTurbo";
import CopilotMaxTurbo from "./screens/products/CopilotMaxTurbo";
import CopilotMaxlt from "./screens/products/CopilotMaxlt";
import CopilotGemini from "./screens/products/CopilotGemini";

import UspJetStream2 from "./screens/products/UspJetStream2";
import UspJetStreamDualHead from "./screens/products/UspJetStreamDualHead";
import UspA2120 from "./screens/products/UspA2120";
import UspCo2Laser from "./screens/products/UspCo2Laser";
import UspHandHeldFiberLaser from "./screens/products/UspHandHeldFiberLaser";
import UspFiberLaser from "./screens/products/UspFiberLaser";
import UspUvLaser from "./screens/products/UspUvLaser";

import Event from "./screens/services/Event";
import Support from "./screens/services/Support";
import Blog from "./screens/services/Blog";
import ContactUs from "./screens/services/ContactUs";

import ByIndustry from "./screens/solutions/ByIndustry";
import ByApplication from "./screens/solutions/ByApplication";

import AutoMobile from "./screens/solutions/AutoMobile";
import BreweriesPage from "./screens/solutions/BreweriesPage";
import Chemical from "./screens/solutions/Chemical";
import Electrical from "./screens/solutions/Electrical";
import FoodBeverage from "./screens/solutions/FoodBeverage";
import PersonalCare from "./screens/solutions/PersonalCare";
import PharmaPage from "./screens/solutions/PharmaPage";
import TelecomAndInfrastrcture from "./screens/solutions/TelecomAndInfrastrcture";

import Login from "./screens/Login";
import VerifyOtp from "./screens/otppage/VerifyOtp";
import PersonalInfo from "./screens/otppage/PersonalInfo";

const Navigation = () => {
  // Convert session value to boolean
  const loginTrue = sessionStorage.getItem("auth") === "true";

  // Theme
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  // Floating Share Button
  const [isOpen, setIsOpen] = useState(false);
  const [visibleIcons, setVisibleIcons] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  // Disable developer options
  // useEffect(() => {
  //   document.addEventListener("contextmenu", (e) => e.preventDefault());

  //   const disableKeys = (e) => {
  //     if (
  //       e.key === "F12" ||
  //       (e.ctrlKey && e.shiftKey && e.key === "I") ||
  //       (e.ctrlKey && e.shiftKey && e.key === "J") ||
  //       (e.ctrlKey && e.key === "U")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener("keydown", disableKeys);

  //   return () => {
  //     document.removeEventListener("contextmenu", (e) => e.preventDefault());
  //     document.removeEventListener("keydown", disableKeys);
  //   };
  // }, []);

  // ICON ANIMATION
  useEffect(() => {
    if (isOpen) {
      for (let i = 0; i < 5; i++) {
        setTimeout(() => {
          setVisibleIcons((prev) => {
            const updated = [...prev];
            updated[4 - i] = true;
            return updated;
          });
        }, i * 150);
      }
    } else {
      setVisibleIcons([false, false, false, false, false]);
    }
  }, [isOpen]);

  // THEME HANDLER
  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "light" ? "dark" : "light"));

  return (
    <BrowserRouter>
      <ScrollToTop />

      {/* ROUTES */}
      <Routes>
        {loginTrue ? (
          <>
            <Route path="/" element={<Home />} />
            <Route path="/knowUs" element={<KnowAs />} />

            {/* PRODUCTS */}
            <Route
              path="/product/uspSimacolorFluids"
              element={<UspSimacolorFluids />}
            />
            <Route path="/product/uspTtoRibbons" element={<UspTtoRibbons />} />
            <Route
              path="/product/uspStreamLine4SP"
              element={<UspStreamLine4SP />}
            />
            <Route path="/product/uspCo2Laser" element={<UspCo2Laser />} />
            <Route
              path="/product/uspHandHeldFiberLaser"
              element={<UspHandHeldFiberLaser />}
            />
            <Route path="/product/uspFiberLaser" element={<UspFiberLaser />} />
            <Route path="/product/uspUvLaser" element={<UspUvLaser />} />
            <Route path="/product/uspJetStream2" element={<UspJetStream2 />} />
            <Route path="/product/uspJetStreamDualHead" element={<UspJetStreamDualHead />} />
            <Route path="/product/uspA2120" element={<UspA2120 />} />
            <Route path="/product/uspTto03s05s" element={<UspTto03s05s />} />
            <Route path="/product/copilot128-256" element={<CopilotAll />} />
            <Route path="/product/Copulot128" element={<CopilotAll />} />
            <Route path="/product/copilot256" element={<CopilotAll />} />
            <Route path="/product/copilotMax400" element={<CopilotMax400 />} />
            <Route
              path="/product/copilotMax512iTurbo"
              element={<CopilotMax512iTurbo />}
            />
            <Route
              path="/product/copilotMaxTurbo"
              element={<CopilotMaxTurbo />}
            />
            <Route path="/product/copilotMaxlt" element={<CopilotMaxlt />} />
            <Route path="/product/copilotGemini" element={<CopilotGemini />} />

            {/* SERVICES */}
            <Route path="/services/support" element={<Support />} />
            <Route path="/services/event" element={<Event />} />
            <Route path="/services/blog" element={<Blog />} />
            <Route path="/services/contactus" element={<ContactUs />} />

            {/* SOLUTIONS */}
            <Route path="/solutions/byIndustry" element={<ByIndustry />} />
            <Route
              path="/solutions/byApplication"
              element={<ByApplication />}
            />

            {/* INDUSTRY PAGES */}
            <Route path="/byindustry/automobile" element={<AutoMobile />} />
            <Route path="/byindustry/breweries" element={<BreweriesPage />} />
            <Route path="/byindustry/chemical" element={<Chemical />} />
            <Route path="/byindustry/electrical" element={<Electrical />} />
            <Route
              path="/byindustry/foodandbeverage"
              element={<FoodBeverage />}
            />
            <Route path="/byindustry/personalCare" element={<PersonalCare />} />
            <Route path="/byindustry/pharma" element={<PharmaPage />} />
            <Route
              path="/byindustry/telecom"
              element={<TelecomAndInfrastrcture />}
            />
          </>
        ) : (
          <>
            <Route path="/" element={<Login />} />
            <Route path="/verifyotp" element={<VerifyOtp />} />
            <Route path="/personalInformation" element={<PersonalInfo />} />
          </>
        )}
      </Routes>

      {/* THEME TOGGLE */}
      {loginTrue && (
        <div className="theme-toggle" onClick={toggleTheme}>
          {theme === "light" ? <FaMoon /> : <FaSun />}
        </div>
      )}

      {/* FLOATING SHARE BUTTON */}
      {loginTrue && !isOpen && (
        <>
          <button className="blog_content_bottom_btn">
            tap to connect here
          </button>

          <div className="blog_bottom_share" onClick={() => setIsOpen(true)}>
            +
          </div>
        </>
      )}

      {/* FLOATING SHARE ICONS */}
      {isOpen && (
        <>
          <div className="blog_share_icons_block show">
            {[
              // { src: Images?.whatsappIcon },
              // { src: Images?.facebookIcon },
              // { src: Images?.instagramIcon },
              {
                src: Images?.linkedin,
                href: SOCIAL_LINKS.linkedin,
              },
              {
                src: Images?.youtueIcon,
                href: SOCIAL_LINKS.youtube,
              },
            ].map((icon, index) => {
              const img = (
                <img
                  src={icon.src}
                  alt="icon"
                  className={`blog_share_icones_sizes ${
                    visibleIcons[index] ? "showIcon" : ""
                  }`}
                />
              );

              return icon.href ? (
                <a
                  key={index}
                  href={icon.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {img}
                </a>
              ) : (
                React.cloneElement(img, { key: index })
              );
            })}
          </div>

          <div className="blog_bottom_share" onClick={() => setIsOpen(false)}>
            x
          </div>
        </>
      )}

      {/* FOOTER (ONLY WHEN LOGGED IN) */}
      {/* {loginTrue && <Footer />} */}
    </BrowserRouter>
  );
};

export default Navigation;
